import { QuestionDifficultyInsert, QuestionDifficultyDelete, QuestionDifficultyUpdate, QuestionDifficultyGetById, QuestionDifficultyGetList, QuestionDifficultyGetPageList } from "@/api/questiondifficulty/index.js";

const state = {

}

const getters = {

}

const mutations = {

}

const actions = {
    // 新增
    QuestionDifficultyInsert(context, payload) {
        return new Promise((resolve, reject) => {
            
            
            QuestionDifficultyInsert({ ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 更新
    QuestionDifficultyUpdate(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            QuestionDifficultyUpdate(id, { ...payload }).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取
    QuestionDifficultyGetById(context, payload) {
        let { id } = payload
        return new Promise((resolve, reject) => {
            QuestionDifficultyGetById(id).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取列表
    QuestionDifficultyGetList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            QuestionDifficultyGetList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    },
    // 获取分页列表
    QuestionDifficultyGetPageList(context, payload) {
        return new Promise((resolve, reject) => {
            let params = { ...payload }
            QuestionDifficultyGetPageList(params).then((response) => {
                let result = response.data
                resolve(result)
            }).catch((err) => {
                reject(err)
            })
        })
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}